module.exports = __webpack_public_path__ + "img/symbol_8.fe3cfef0.png";